import { Button, DocumentIcon } from "@UI";
import { isToolUIPart } from "ai";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { HookCard, HookTile } from "./HookCard";
const DOCX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export function wordFileOf(part) {
    if (!isToolUIPart(part) || part.state !== "output-available") return null;
    const file = part.output?.file;
    if (file?.mimeType !== DOCX_MIME_TYPE || typeof file.url !== "string" || typeof file.filename !== "string") return null;
    return file;
}
export function WordFileCard({ file }) {
    const { t } = useTranslation();
    const [isOpening, setIsOpening] = useState(false);
    const [hasFailed, setHasFailed] = useState(false);
    const openInWord = async ()=>{
        setIsOpening(true);
        setHasFailed(false);
        try {
            const response = await fetch(file.url);
            if (!response.ok) throw new Error(`Document download failed with status ${response.status}`);
            const base64 = window.btoa(new Uint8Array(await response.arrayBuffer()).reduce((data, byte)=>data + String.fromCharCode(byte), ""));
            await Word.run(async (context)=>{
                context.application.createDocument(base64).open();
                await context.sync();
            });
        } catch (err) {
            console.error(err);
            setHasFailed(true);
        } finally{
            setIsOpening(false);
        }
    };
    return /*#__PURE__*/ React.createElement(HookCard, null, /*#__PURE__*/ React.createElement("div", {
        className: "hook-head"
    }, /*#__PURE__*/ React.createElement(HookTile, null, /*#__PURE__*/ React.createElement(DocumentIcon, {
        size: 16
    })), /*#__PURE__*/ React.createElement("div", {
        className: "hook-text"
    }, /*#__PURE__*/ React.createElement("h4", null, file.filename))), hasFailed && /*#__PURE__*/ React.createElement("p", {
        className: "hook-error"
    }, t("chat.file.openFailed")), /*#__PURE__*/ React.createElement("div", {
        className: "hook-actions"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        onClick: ()=>window.open(file.url)
    }, t("chat.file.download")), /*#__PURE__*/ React.createElement(Button, {
        loading: isOpening,
        onClick: openInWord
    }, t("chat.file.openInWord"))));
}
